import React, {useEffect, useState} from 'react';
import Wrapper from "../components/Wrapper.js";
import {useDispatch, useSelector} from "react-redux";
import DatePicker from "react-datepicker";
import moment from "moment";
import Api from "../Api.js";
import {accountantRequest, taskManagerRequest} from "../store/actions/task.js";
import {Autocomplete, Collapse, TextField} from "@mui/material";
import {REACT_APP_API_URL} from "../config.js";
import ErrorToast from "../components/BlueButton/ErrorToast.js";
import {Button} from "react-bootstrap";

function Reports(props) {
    const dispatch = useDispatch()
    const [active, setActive] = useState("accountant");
    const [id, setId] = useState(null);
    const [value, setValue] = useState(null);
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [filterStartDate, setFilterStartDate] = useState("");
    const [filterEndDate, setFilterEndDate] = useState("");
    const [result, setResult] = useState([]);
    const [allDuration, setAllDuration] = useState(null);
    const [open, setOpen] = useState(false);
    const [template, setTemplate] = useState([]);
    const account = useSelector((state) => state.task.accountant);
    const managers = useSelector((state) => state.task.managers);
    const handleChangeStartDate = date => {
        const now = new Date();
        if (date <= now) {
            setStartDate(date);
            setFilterStartDate(`${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`);
        }
    };

    const handleChangeFinishDate = date => {
        const now = new Date();
        if (date <= now) {
            setEndDate(date);
            setFilterEndDate(`${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`);
        }
    };
    const link = `${REACT_APP_API_URL}report/${id}/${filterStartDate}/${filterEndDate}/${active}/excel/`;
    useEffect(() => {
        (async () => {
            const {data} = await Api.taskTemplate()
            setTemplate(data.results)

        })();
    }, []);
    const handleReport = async () => {
        try {
            const {data} = await Api.getReport(id, filterStartDate, filterEndDate, active)
            setResult(data.result || []);
            setAllDuration(data.all_duration);
            setOpen(true);
        }  catch (e) {
            ErrorToast()
        }
    };

    const selectedList = () => {
        const options = active === "manager"
            ? managers.filter(el => el.user.is_active)
            : active === "accountant"
                ? account.filter(el => el.user.is_active)
                : template;
        return (
            <Autocomplete
                key={active} // Use active as key to force remount on switch
                id="combo-box-demo"
                options={options}
                value={value}
                onChange={(e, selected) => {
                    if (selected) {
                        setId(selected.id);
                        setValue(selected); // store object for consistent behavior
                    } else {
                        setValue(null);
                        setId(null);
                    }
                }}
                getOptionLabel={option => {
                    if (active === "template") {
                        return option?.name || "";
                    }
                    return option?.user ? `${option.user.first_name} ${option.user.last_name}` : option.toString();
                }}
                renderInput={params => (
                    <TextField
                        {...params}
                        fullWidth
                    />
                )}
            />
        );
    }
    return (
        <Wrapper>
            <div className="reports">
                <div className="reports-buttons">
                    {['accountant', 'manager', 'template'].map(type => (
                        <div
                            key={type}
                            className={active === type ? "report-button-active" : "report-button"}
                            onClick={() => {
                                setActive(type);
                                setId(null);
                                setValue("");
                                setResult([]);
                            }}
                        >
                            {type === "accountant" ? "Աշխատակից" : type === "manager" ? "Մենեջեր" : "Ձևանմուշ"}
                        </div>
                    ))}
                </div>
                <div className="reports-item-cont">
                    <div className="reports-item">
                        <div className="left-green-button  m-0">
            <span>
              {active === "manager"
                  ? "Մենեջեր"
                  : active === "accountant"
                      ? "Աշխատակից"
                      : "Առաջադրանքի վերնագիր"}
            </span>
                        </div>
                        {selectedList()}
                    </div>
                    <div className="reports-item">
                        <div className="left-green-button"><span>Սկիզբ</span></div>
                        <div className="contDatePicker">
                            <DatePicker
                                dateFormat="dd/MM/yyyy"
                                selected={startDate}
                                onChange={handleChangeStartDate}
                            />
                        </div>
                    </div>
                    <div className="reports-item">
                        <div className="left-green-button"><span>Ավարտ</span></div>
                        <div className="contDatePicker">
                            <DatePicker
                                dateFormat="dd/MM/yyyy"
                                selected={endDate}
                                onChange={handleChangeFinishDate}
                            />
                        </div>
                    </div>
                </div>
                {startDate && endDate && startDate <= endDate && id && (
                    <div className="report-buttons">
                        <Button onClick={handleReport}>Տեսնել</Button>
                        <a href={link} download>
                            <div className="tool-tip-cont">
                                <div className="tool-tip">Բեռնել</div>
                                <i className="fa fa-download"/>
                            </div>
                        </a>
                    </div>
                )}
                <div className="table-cont">
                    <Collapse in={open}>
                        <div>
                            <table>
                                {result.length > 0 ? (
                                    <tbody>
                                    <tr>
                                        <th>Կազմակերպության անուն</th>
                                        <th>Առաջադրանքի անուն</th>
                                        <th>Ստեղծվել է</th>
                                        <th>Սկսվել է</th>
                                        <th>Ավարտվել է</th>
                                        <th>Տևել է</th>
                                        <th>Ընդհանուր</th>
                                    </tr>
                                    {result.map((item, index) => (
                                        <tr className='report-list' key={index}>
                                            <td className='report-item'>{item.company_name}</td>
                                            <td className='report-item'>{item.task_name}</td>
                                            <td className='report-item'>
                                                {moment(item.created_date).format('L')} {moment(item.created_date).format('LTS')}
                                            </td>
                                            <td className='report-item'>
                                                {moment(item.created_date).format('L')} {moment(item.start_date).format('LTS')}
                                            </td>
                                            {item.end_date !== "None" && (
                                                <td className='report-item'>
                                                    {moment(item.end_date).format('L')} {moment(item.end_date).format('LTS')}
                                                </td>
                                            )}
                                            <td className='report-item'>{item.duration}</td>
                                            {index === 0 && <td className='report-item'>{allDuration}</td>}
                                        </tr>
                                    ))}
                                    </tbody>
                                ) : (
                                    <span>Առաջադրանքներ չկան</span>
                                )}
                            </table>
                        </div>
                    </Collapse>
                </div>
            </div>
        </Wrapper>
    );
}

export default Reports;